import { SxProps } from '@mui/material';
import { SearchCategoryType } from 'model/gloabalSearch.model';
import { CSSProperties } from 'react';
import zeplinColor from 'theme/Color';

export const container: SxProps = {
  width: '100%',
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  backgroundColor: `${zeplinColor.Neutral1}`,
  padding: '11px',
  border: `1px solid ${zeplinColor.Neutral1}`,
  borderRadius: '14px',
  color: zeplinColor.BasicBlack,

  ':hover': {
    border: `1px solid ${zeplinColor.BasicBlack}`,
    cursor: 'pointer',
  },
};

const iconContainer = {
  backgroundColor: zeplinColor.Neutral4,
  borderRadius: '8px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const imageContainerSharedStyles = {
  width: '40px',
  height: '40px',
  backgroundColor: zeplinColor.Neutral4,
  borderRadius: '20px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const imageContainer: Partial<Record<SearchCategoryType, SxProps>> = {
  clients: imageContainerSharedStyles,
  deals: {
    ...imageContainerSharedStyles,
    ...iconContainer,
  },
  tasks: { ...imageContainerSharedStyles, ...iconContainer },
  leads: imageContainerSharedStyles,
  contacts: imageContainerSharedStyles,
  team: imageContainerSharedStyles,
  business: imageContainerSharedStyles,
};

const profilePictureSharedStyles = {
  width: '100%',
  height: '100%',
  borderRadius: '20px',
  objectFit: 'cover',
} as const;

const iconSharedStyles = {
  width: '22px',
  height: '22px',
  objectFit: 'cover',
  borderRadius: '8px',
} as const;

export const image: Partial<Record<SearchCategoryType, CSSProperties>> = {
  clients: { ...profilePictureSharedStyles },
  deals: { ...iconSharedStyles },
  tasks: { ...iconSharedStyles },
  leads: { ...profilePictureSharedStyles },
  contacts: { ...profilePictureSharedStyles },
  team: { ...profilePictureSharedStyles },
  business: { ...profilePictureSharedStyles, borderRadius: '8px' },
};

export const textContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  alignItems: 'flex-start',
};

export const recentOpenContent: SxProps = {
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  gap: '6px',
};

export const cardChip: SxProps = {
  padding: '4px 8px',
  height: '22px',
  textTransform: 'capitalize',

  '.MuiChip-label': {
    padding: 0,
  },
};
